/** Account-level access rules evaluated from imported collaborator attributes. */
import { ObserverOptions } from "./account.types"

export interface RoleCondition {
  filterName: string
  name: string
}

//Rules of a role that the admin edits (members and dashboard scope)
export type RoleRules = Partial<Pick<Role, "conditions" | "userIds" | "scopeFilterNames" | "scopePopulations" | "observerOptions" | "managerScope">>

export class Role {
  id: string = ""
  AccountId: string | null = null
  name: string = ""
  // AND between filter names, OR between populations of the same filter.
  // Empty conditions must not grant access.
  conditions: RoleCondition[] = []
  // Collaborators added by hand, members whatever their attributes (OR with conditions).
  userIds: string[] = []
  // Match the member's own values for these attributes (AND between attributes).
  // Both scope lists empty grants access to the whole organization.
  // A missing member attribute needs a fixed alternative in the same filter.
  scopeFilterNames: string[] = []
  // Fixed populations shared by all members, combined with dynamic values.
  scopePopulations: RoleCondition[] = []
  // Members are the managers named in the account's managerFilters, each one sees his teams and those below.
  // Replaces the conditions, the collaborators added by hand and both scope lists.
  managerScope: boolean = false
  // Features hidden from the members, added to those hidden by the account (never removed).
  observerOptions: Partial<ObserverOptions> = {}
  // Nombre de membres, calcule par le serveur a partir des conditions.
  usersCount: number = 0

  constructor(item: Partial<Role> = {}) {
    Object.assign(this, item)
    this.conditions = (item.conditions ?? []).map(({ filterName, name }) => ({ filterName, name }))
    this.userIds = [...(item.userIds ?? [])]
    this.scopeFilterNames = [...(item.scopeFilterNames ?? [])]
    this.scopePopulations = (item.scopePopulations ?? []).map(({ filterName, name }) => ({ filterName, name }))
    this.observerOptions = { ...item.observerOptions }
  }

  //The role hides something more than the account
  get hasObserverOptions(): boolean {
    const { dashboardTabsHiddenForObserver = [], ...flags } = this.observerOptions
    return dashboardTabsHiddenForObserver.length > 0 || Object.values(flags).some(Boolean)
  }
}
